import { render } from "./viewDealerGroup.vue?vue&type=template&id=021287ee"
import script from "./viewDealerGroup.vue?vue&type=script&lang=js"
export * from "./viewDealerGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__